import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';

import { TranslatePipe } from '@ngx-translate/core';
import { FooterButton, FooterService } from './footer.service';
import { AsyncPipe } from '@angular/common';

import { isObservable, Observable, of } from 'rxjs';

@Component({
  selector: 'app-footer',
  imports: [MatButton, TranslatePipe, AsyncPipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  leftButton: FooterButton | undefined;
  rightButton: FooterButton | undefined;

  constructor(private footerService: FooterService) {
    this.footerService.leftButton$.subscribe((button) => {
      this.leftButton = button;
    });
    this.footerService.rightButton$.subscribe((button) => {
      this.rightButton = button;
    });
  }

  getDisabledState(
    disabled: boolean | Observable<boolean> | undefined,
  ): Observable<boolean> {
    return isObservable(disabled) ? disabled : of(!!disabled);
  }
}
